import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ParticlesBackground from './components/Particles';
import Header from './components/Header';
import About from './pages/about/_index';
import Careers from './pages/careers/_index';
import News from './pages/news/_index';
import Home from './pages/home/_index';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ParticlesBackground />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} /> */}
        {/* <Route path="/careers" element={<Careers />} /> */}
        {/* <Route path="/news" element={<News />} /> */}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
); 